import { PARTS, TIERS } from "./parts";

const ORDER = ["easy", "medium", "hard"];
const LEVELS = [["easy", 5], ["medium", 5], ["hard", 3]];
export const tierLabel = (t) => TIERS.find((x) => x.key === t)?.label || t;
const TIER_OF = (n) => { let k = n; for (const [t, c] of LEVELS) { if (k <= c) return t; k -= c; } return "hard"; };

export const MOCKS = Array.from({ length: LEVELS.reduce((s, [, c]) => s + c, 0) }, (_, k) => {
  const n = k + 1, tier = TIER_OF(n);
  return { id: `test-${n}`, n, tier, title: `Test ${n} · ${tierLabel(tier)}`, blurb: `${tierLabel(tier)} level · mostly ${tierLabel(tier).toLowerCase()} questions with some from other levels · Parts A–I.` };
});

export const mockTitle = (entry) => {
  const id = entry?.mockId || "";
  const n = id.match(/^(?:test|mock)-(\d+)$/)?.[1];
  if (entry?.level && n) return `Test ${n} · ${tierLabel(entry.level)}`;
  return n ? `Test ${n}` : id === "dynamic" ? "Test (randomized)" : entry?.title || "Test";
};

export const mixOf = (seq) => ORDER.reduce((o, t) => ({ ...o, [t]: seq.filter((s) => s.item.difficulty === t).length }), {});
export const mixLabel = (entry) => (entry?.mix ? ORDER.filter((t) => entry.mix[t]).map((t) => `${entry.mix[t]} ${tierLabel(t)}`).join(" · ") : "");

// Half of each part from the mock's own level, the rest split across the other two (nearest first)
const tierCounts = (tier, count) => {
  const others = ORDER.filter((t) => t !== tier).sort((a, b) => Math.abs(ORDER.indexOf(a) - ORDER.indexOf(tier)) - Math.abs(ORDER.indexOf(b) - ORDER.indexOf(tier)));
  const own = Math.ceil(count / 2), rest = count - own, near = Math.ceil(rest / 2);
  return { [tier]: own, [others[0]]: near, [others[1]]: rest - near };
};

export const buildExam = (mockId, bank, short = false) => {
  const m = MOCKS.find((x) => x.id === mockId);
  if (!m) return [];
  return PARTS.flatMap((p) => {
    const count = short ? 1 : p.exam;
    // Consecutive, non-overlapping slices per level: earlier mocks' demand sets this mock's offset
    return ORDER.flatMap((t) => {
      const offset = MOCKS.filter((x) => x.n < m.n).reduce((s, x) => s + tierCounts(x.tier, count)[t], 0);
      return bank[p.key].filter((x) => !x.ai && x.difficulty === t).slice(offset, offset + tierCounts(m.tier, count)[t]);
    }).map((item) => ({ part: p.key, item }));
  });
};

export const examItemCount = () => PARTS.reduce((s, p) => s + p.exam, 0);
